import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../../actionTypes';

const initialState = false;

const isFetching = () => true;

const isFinishing = () => false;

export default createReducer(initialState, {
  [types.DUPLICATE]: isFetching,
  [types.DUPLICATE_SUCCESS]: isFinishing,
  [types.DUPLICATE_FAILURE]: isFinishing,
  [types.HIDE_DUPLICATE_MODAL]: isFinishing,
});
